import axios from 'axios';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Entry, EntryData } from '@/models/Entry';
import { Vue } from 'vue-property-decorator';
import { Form } from '@/models/Form';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export interface IEntries {
    [formUri: string]: {
        [entryUri: string]: Entry;
    };
}

@Module({ namespaced: true })
class EntryModule extends VuexModule {
    _all: IEntries = {};

    get all(): IEntries {
        return this._all;
    }

    @Mutation
    add(entry: Entry) {
        if (!this._all[entry.form]) {
            this._all[entry.form] = {};
        }
        Vue.set(this._all[entry.form], entry.uri, entry);
    }

    @Mutation
    remove(entry: Entry) {
        Vue.delete(this._all[entry.form], entry.uri);
    }

    @Action
    async read(form: number) {
        try {
            const r = await axios({
                method: 'GET',
                url: `/api/entries?form=${form}`,
            });
            return r.data['hydra:member'].map((data: EntryData) => {
                this.context.commit('add', new Entry(data));
            });
        } catch (e) {
            return e;
        }
    }

    @Action
    async create(data: Entry) {
        try {
            const r = await axios({
                method: 'POST',
                url: '/api/entries',
                data,
            });

            if (r.status !== 201) {
                throw Error('Entry CREATE failed.');
            }
            this.context.commit('add', new Entry(r.data));
        } catch (e) {
            return e;
        }
    }

    @Action
    async delete(data: Entry) {
        try {
            const r = await axios({
                method: 'DELETE',
                url: `/api/entries/${data.id}`,
            });

            if (r.status !== 204) {
                throw Error('Entry DELETE failed.');
            }

            this.context.commit('remove', data);
        } catch (e) {
            return e;
        }
    }

    @Action
    async import({ form, data }: { form: Form; data: any }) {
        try {
            const r = await axios({
                method: 'POST',
                url: `/api/entry/importcsv/${form.id}`,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                data,
            });
            // TODO Get new entries and add to state.
        } catch (e) {
            return e;
        }
    }
}

export default EntryModule;
